import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card8 from "../Images/Profiles/Jonah.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function GoodchildIsingomaYonah() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Goodchild Isingoma Yonah - Transport Officer"
        description="Mr. Goodchild Isingoma Yonah is a Transport Officer at CIRCODU with a secondary education certificate and a CM & B driving permit."
        keywords="Goodchild Isingoma Yonah, Transport Officer, CIRCODU, secondary education certificate, CM & B driving permit"
        url="/goodchild-isingoma-yonah"
        image={Card8}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Goodchild Isingoma Yonah</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Goodchild Isingoma Yonah
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card8} alt="Mr. Goodchild Isingoma Yonah" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">
                  Mr. Goodchild Isingoma Yonah
                </h1>
                <p className="profile-card__role">Transport Officer</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Isingoma Yonah possesses a secondary education certificate and
                  holds a CM & B driving permit. His qualifications encompass
                  certificates in competent driving, which have been awarded by
                  the Ministry of Works. Additionally, he has obtained a
                  certificate in safety observation and corrective action from
                  Tullow Oil, along with a defensive driving certificate
                  accredited by the Automobile Association of Uganda.
                </p>
                <p>
                  His career journey has featured diverse roles. He began as a
                  field assistant at Cash Farm Uganda and subsequently served as
                  an agricultural manager at Rweboha Religious Community. Over
                  the years, he has also honed his skills as a driver, gaining
                  experience at Gate 1 Travel, Mineral Services Ltd, East
                  African Diary and Food Limited, and Anifarm Creameries.
                  Presently, he holds the role of Transport Officer at CIRCODU.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Circodu/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256751178448"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:isingoma.jonah@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GoodchildIsingomaYonah;
